import { render, staticRenderFns } from "./ModalEvolucaoIndicador.vue?vue&type=template&id=37241cd2&scoped=true"
import script from "./ModalEvolucaoIndicador.vue?vue&type=script&lang=js"
export * from "./ModalEvolucaoIndicador.vue?vue&type=script&lang=js"
import style0 from "./ModalEvolucaoIndicador.vue?vue&type=style&index=0&id=37241cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37241cd2",
  null
  
)

export default component.exports